var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMirror = function SvgMirror(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a4.5 4.5 0 0 0-4.5 4.5V14h9V6.5A4.5 4.5 0 0 0 8 2ZM2.5 6.5a5.5 5.5 0 1 1 11 0v8a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8Z",
    fill: "currentColor"
  })));
};
export default SvgMirror;